jQuery(function($) {

	$( document ).ready(function() {
		$( ".why-attend-container .find-out-more" ).click(function() {
      if($(this).closest('.arival-block-container').hasClass('is-active')){
        $(this).closest('.arival-block-container').removeClass('is-active')
        $(this).closest('.arival-block-container').find('.arival-block-findmore').slideUp( "slow" );
      } else {
        $(this).closest('.arival-block-container').addClass('is-active')
        $(this).closest('.arival-block-container').find('.arival-block-findmore').slideDown( "slow" );
      };
    });

		if($(".fixed-button").length){

			var navHeight = $('#wpadminbar').outerHeight(true) + $('.arival-header').outerHeight(true) + 32;
      var distance = $('.fixed-button').offset().top - navHeight;

			$(window).on("scroll", function(e) {
				var currentScroll = $(window).scrollTop()
				if (currentScroll > distance) {
				  $(".fixed-button").addClass("fixed");
				} else {
				  $(".fixed-button").removeClass("fixed");
				}
			});
		}

	});

	if($(".countdown-overlay").length){
		simplyCountdown('.countdown-overlay', {
		    year: countdownYear, // required
		    month: countdownMonth, // required
		    day: countdownDay, // required
		    hours: countdownHours, // Default is 0 [0-23] integer
		    minutes: countdownMinutes, // Default is 0 [0-59] integer
		    seconds: countdownSeconds, // Default is 0 [0-59] integer
			enableUtc: true,
	  });
	}

});
